// ES
export const hotelRatesManager = {
  perNight: "/ noche",
  roomFallback: "Habitación #{id}",

  header: {
    eyebrow: "Tarifas principales",
    title: "Tarifas del hotel",
    subtitle:
      "Crea tarifas base y aplícalas a una o varias habitaciones. Las tarifas derivadas se sincronizan con el channel manager.",
    newMain: "Nueva tarifa principal",
  },
  states: {
    loading: "Cargando tarifas…",
    emptyTitle: "Sin tarifas todavía",
    emptySubtitle:
      "Crea la primera tarifa principal para comenzar a gestionar precios y sincronizar con el channel manager.",
    createFirst: "Crear primera tarifa",
  },
  card: {
    mainBadge: "Principal",
    occupancy: "Ocup. {count}",
    minStay: "Mín. {count} noche | Mín. {count} noches",
    editRate: "Editar tarifa",
    deleteRate: "Eliminar tarifa",
    rooms: "Habitaciones",
    syncedTooltip: "Sincronizado con channel manager",
    removeSyncedTooltip: "Quitar (advertencia: channel manager)",
    removeRoomTooltip: "Quitar de esta habitación",
    add: "Agregar",
    selectRoom: "Selecciona habitación",
    derivedBadge: "Derivada",
    derivedFrom: "de {name}",
    sameNameHint: "Hay otra «{name}» con otro precio o condiciones. Cada tarjeta se edita por separado.",
    editDerived: "Editar derivada",
    deleteDerived: "Eliminar derivada",
  },
  derived: {
    toggle: "Tarifas derivadas",
    empty:
      "Sin tarifas derivadas. Crea una para Booking.com, Airbnb u OTAs específicas.",
    newDerived: "Nueva tarifa derivada",
  },
  common: {
    allRooms: "todas las habitaciones",
    cancel: "Cancelar",
    saving: "Guardando…",
    creating: "Creando…",
    saveChanges: "Guardar cambios",
    removeAll: "Quitar todo",
  },
  mainModal: {
    editTitle: "Editar tarifa principal",
    newTitle: "Nueva tarifa principal",
    nameLabel: "Nombre",
    namePlaceholder: "Ej: Tarifa estándar, Fin de semana…",
    priceLabel: "Precio por noche",
    occupancyLabel: "Ocupación",
    minStayLabel: "Estancia mínima (noches)",
    maxStayLabel: "Estancia máxima (noches)",
    validityLabel: "Vigencia",
    permanent: "Permanente",
    dateRange: "Rango de fechas",
    from: "Desde",
    to: "Hasta",
    descriptionLabel: "Descripción (opcional)",
    descriptionPlaceholder: "Notas internas sobre esta tarifa…",
    searchPlaceholder: "Buscar habitación…",
    selectAllShort: "Todo",
    noResults: 'Sin resultados para "{query}"',
    noRoomsAvailable: "Sin habitaciones disponibles",
    editInfo: "Los cambios se aplicarán a {rooms} de esta tarjeta.",
    createRate: "Crear tarifa",
  },
  derivedModal: {
    editTitle: "Editar tarifa derivada",
    newTitle: "Nueva tarifa derivada",
    subtitle: "Derivada de {name} · {price}",
    nameLabel: "Nombre de la tarifa derivada",
    namePlaceholder: "Ej: Booking.com, Airbnb, Sin desayuno…",
    nameHint: "Este nombre identifica la tarifa en el channel manager.",
    adjustTypeLabel: "Tipo de ajuste",
    percentage: "Porcentaje",
    fixedAmount: "Importe fijo",
    adjustValueLabel: "Valor del ajuste",
    adjustValueHint: "(negativo = descuento)",
    resultPriceLabel: "Precio resultante",
    baseLabel: "Base",
    applyToRooms: "Aplicar a habitaciones",
    onlyMainRooms: "Solo se muestran habitaciones que tienen la tarifa principal.",
    noRoomsWithMain: "La tarifa principal no está aplicada a ninguna habitación todavía.",
    selectAll: "Seleccionar todo",
    editInfo:
      "Al editar se actualizará el ajuste en {rooms} que tienen esta tarifa derivada.",
    createDerived: "Crear derivada",
  },
  removeModal: {
    title: "Quitar de habitación",
    syncWarnTitle: "Esta tarifa está sincronizada con el channel manager",
    syncWarnBody:
      "Eliminarla puede {break} de tarifas en Channex para esta habitación. Verifica en el channel manager antes de continuar.",
    syncWarnBreak: "romper la sincronización",
    confirmText: "Esta acción eliminará la tarifa {rate} de la habitación {room}.",
    roomLabel: "Habitación",
    rateLabel: "Tarifa",
    statusLabel: "Estado",
    syncedWithChannex: "Sincronizado con Channex",
    removing: "Eliminando…",
    removeAnyway: "Entiendo, quitar de todas formas",
    confirm: "Quitar de habitación",
  },
  deleteModal: {
    title: "Eliminar tarifa",
    warnTitle: "Esta acción no se puede deshacer",
    warnBody: "Se eliminará la tarifa {rate} de {rooms}.",
    roomsCount: "{count} habitación | {count} habitaciones",
    syncedWarn:
      "Algunas habitaciones están sincronizadas con Channex. Esto puede afectar la sincronización de tarifas.",
    confirmLabel: "Escribe {name} para confirmar",
    deleting: "Eliminando…",
    confirm: "Eliminar definitivamente",
  },
  toasts: {
    loadError: "Error al cargar las tarifas del hotel",
    mainCreated: "Tarifa creada en {count} habitación | Tarifa creada en {count} habitaciones",
    createdPartial: "{ok} creada(s), {fail} con error",
    mainCreateFailAll: "No se pudo crear la tarifa en ninguna habitación",
    mainUpdated: "Tarifa actualizada",
    updatedPartial: "{ok} actualizada(s), {fail} con error",
    mainUpdateFail: "No se pudo actualizar la tarifa",
    derivedCreated:
      "Derivada creada en {count} habitación | Derivada creada en {count} habitaciones",
    derivedCreateFail: "No se pudo crear la tarifa derivada",
    derivedUpdated: "Derivada actualizada",
    derivedUpdateFail: "No se pudo actualizar la tarifa derivada",
    roomAddedMain: "Tarifa agregada a {room}",
    addRateError: "Error al agregar la tarifa",
    noMainRate: "Esta habitación no tiene la tarifa principal. Agrégala primero.",
    roomAddedDerived: "Derivada agregada a {room}",
    addDerivedError: "Error al agregar la derivada",
    rateRemoved: "Tarifa quitada de {room}",
    removeError: "Error al quitar la tarifa",
    rateDeleted: "Tarifa eliminada",
    deletedPartial: "{ok} eliminada(s), {fail} con error",
    deleteError: "Error al eliminar",
  },
  errors: {
    invalidRange: "Selecciona un rango de fechas válido",
    startAfterEnd: "La fecha inicio no puede ser mayor que la de fin",
    minStayRange: "Estancia mínima: {minStay} noches, pero el rango tiene {nights}",
  },
};
